export const ID_COUNTRY_RUSSIA = 1;
export const BYTES_IN_MB = 1_048_576;
